<div class="lock-bid-dialog">
  <!-- Header -->
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>{{ is_locked == 1 ? 'lock' : 'lock_open' }}</mat-icon>
    </div>
    <h2>{{ (is_locked == 1 ? 'Lock' : 'Unlock') + ' ' + title }}</h2>
    <button class="close-btn" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content" [formGroup]="sectionForm">
    <div class="message-text">
      @if (is_locked == 1) {
        <p>
          Locking the {{ title | lowercase }} will disable the {{ title | lowercase }} from being edited.
        </p>
      } @else {
        <p>Unlocking the {{ title | lowercase }} will enable the {{ title | lowercase }} to be edited.</p>
      }
    </div>
  </div>

  <!-- Footer -->
  <div class="dialog-footer">
    <button class="btn-cancel" mat-dialog-close>
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button class="btn-submit" (click)="unlock()">
      <mat-icon>{{ is_locked == 1 ? 'lock' : 'lock_open' }}</mat-icon>
      <span>{{ (is_locked == 1 ? 'Lock' : 'Unlock') + ' ' + title }}</span>
    </button>
  </div>
</div>
